import React, { useCallback, useState, memo, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getHistoricoEmbarque } from "../../../services/ModuloGerenciador/Embarque";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import NavbarV3 from "../../../components/NavbarV3/NavbarV3.tsx";
import HeaderCadastro from "../../../components/HeaderCadastro/HeaderCadastro.js";
import CloseIcon from "../../../components/CloseIcon/CloseIcon.js";
import CadastroViagem from "../Embarque/StepperV2/CadastroViagem.js";
import { getTemplateEmbarquePorId } from "../../../services/ModuloGerenciador/TemplateEmbarque.js";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent.tsx";

function EditarModeloViagens() {
	const { profile } = useProfile();
	const navigate = useNavigate();
	const params = useParams();

	const [loading, setLoading] = useState(true);
	const [values, setValues] = useState({
		dataEmbarque: "",
		dataEntrega: "",
		previsaoEmbarque: "",
		previsaoEntrega: "",
		embarqueHistoricoId: "",
		embarqueId: "",
		embarqueTemplateId: "",
		embarqueTemplateHistoricoId: "",
		observacao: "",
	});

	const formatDate = useCallback((dateString: string): string => {
		const date = new Date(dateString);
		const dd = String(date.getDate()).padStart(2, "0");
		const mm = String(date.getMonth() + 1).padStart(2, "0");
		const yyyy = date.getFullYear();
		return `${yyyy}-${mm}-${dd}`;
	}, []);

	const buscarTemplatePorId = useCallback(async () => {
		if (!params.id) return;
		if (!profile?.token) return;

		setLoading(true);
		try {
			const result = await getTemplateEmbarquePorId(params.id, profile.token);
			if (result.status === 200) {
				const formattedData = {
					...result.data,
					previsaoEntrega: formatDate(result.data.previsaoEntrega),
					dataEmbarque: formatDate(result.data.dataEmbarque),
					dataEntrega: formatDate(result.data.dataEntrega),
					previsaoEmbarque: formatDate(result.data.previsaoEmbarque),
				};
				setValues(formattedData);
			}
		} catch (error) {
			navigate("/modelo-viagens");
		}
		setLoading(false);
	}, [params]);

	useEffect(() => {
		buscarTemplatePorId();
	}, [params]);

	const isLoading = useMemo(() => {
		return loading || !profile?.token || !params.id;
	}, [loading, profile, params]);

	return (
		<div>
			<NavbarV3 title="Edição de Viagens - Modelo Viagens" />
			<div className="indicadores">
				<div className="texto-cadastro">
					<p className="indicador-emb">{"Dados do Modelo / "}</p>
					<p className="indicador-emb">Edição de Modelo de Viagens</p>
					<HeaderCadastro texto="" />
				</div>
				<div className="close-btn">
					<CloseIcon
						onClick={() => {
							navigate("/modelo-viagens");
						}}
					/>
				</div>
			</div>
			{isLoading && <LoadingComponent />}
			{!isLoading && <CadastroViagem dados={values} />}
		</div>
	);
}

export default memo(EditarModeloViagens);
